import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nutzungsbedingungen-portal',
  templateUrl: './nutzungsbedingungen-portal.component.html',
  styleUrls: ['./nutzungsbedingungen-portal.component.scss']
})
export class NutzungsbedingungenPortalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
